<template>
  <div>
    <el-form inline size="mini" label-width="160px" :model="conditions">
      <el-row :gutter="24">
        <el-col :lg="8" :md="12">
          <el-form-item label="包材采购周期（天）">
            <el-input v-model="conditions.pocycle" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="包材安全预警量（件）">
            <el-input v-model="conditions.powarning" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="全流程标识">
            <el-radio v-model="conditions.fflag" label="X">是</el-radio>
            <el-radio v-model="conditions.fflag" label="">否</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    prod: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      conditions: {
        pocycle: '',
        powarning: '',
        fflag: ''
      }
    }
  },
  created() {
    for (const key in this.conditions) {
      this.conditions[key] = this.prod[key]
    }
  },
  methods: {
    submitForm() {
      return this.conditions
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/product-manage/components/PlanAttr.vue